import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_TattooFromPhotoConverter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter',
			name: 'Tattoo From Photo Converter — Transform Images into Tattoo Designs Online | Lift',
			description:
				'Convert image to tattoo designs instantly with AI. No watermark. Upload images, choose style and placement, and transform any picture into a custom tattoo stencil. Try now!',
			url: 'https://liftapp.ai/tattoo-from-photo-converter',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/tattoo-from-photo-converter#product' },
				{ '@id': 'https://liftapp.ai/tattoo-from-photo-converter#howto' },
				{ '@id': 'https://liftapp.ai/tattoo-from-photo-converter#benefits' },
				{ '@id': 'https://liftapp.ai/tattoo-from-photo-converter#faq' },
				{ '@id': 'https://liftapp.ai/tattoo-from-photo-converter#why-lift' },
				{
					'@id': 'https://liftapp.ai/tattoo-from-photo-converter#explore-tools',
				},
				{ '@id': 'https://liftapp.ai/tattoo-from-photo-converter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter#product',
			name: 'Image to Tattoo Converter',
			description:
				"Transform photos into custom tattoo designs with AI in seconds. Upload images and visualize any tattoo idea on your desired body part. Try Lift's Photo to Tattoo Converter now!",
			url: 'https://liftapp.ai/tattoo-from-photo-converter',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Choose your style & placement',
					text: 'Select from a range of tattoo styles and pick the exact body part where you want your tattoo',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Describe your vision',
					text: 'Write your tattoo idea in detail or keep it simple — our AI photo to tattoo converter understands your concept',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Add reference images',
					text: 'Upload reference photos for inspiration, and let our AI image to tattoo generator bring your vision to life.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download your design',
					text: 'Get your AI generated tattoo instantly — ready to show your tattoo artist or save for later',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter#benefits',
			name: "Who can benefit from Lift's AI Image to Tattoo Generator?",
			description:
				"Lift's AI Image to Tattoo Generator helps first-time clients, creative individuals, and anyone looking to visualize tattoo designs from photos before committing.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'AI tattoo generator for first-time clients — Preview your tattoo design on the exact body placement before committing. Avoid regret, explore styles safely, and feel confident choosing the perfect AI generated tattoo.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Tattoo AI for unique custom ideas — Stop relying on overused inspiration. Lift works as a tattoo design creator that helps you generate original concepts tailored to your personality in seconds.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Tattoo AI generator for clear visual references — Struggling to explain your vision to an artist? Turn prompts and reference photos into a detailed tattoo generator image, making communication easy and accurate.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Tattoo generator AI for placement and style testing — Not sure what fits best on your arm, back, or leg? Instantly try multiple looks with the best AI tattoo generator experience online.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'AI tattoo generator for creative typography and lettering — Create script, monogram, or custom text designs with a letter tattoo generator and lettering tattoo maker, perfect for personalized tattoo concepts.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Photo to tattoo converter showing AI-generated tattoo design previewed on shoulder',
				description:
					'Photo to tattoo converter showing AI-generated tattoo design previewed on shoulder.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Photo to Tattoo Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Photo to Tattoo Converter is a online tool that instantly transforms any image into custom tattoo designs using artificial intelligence — perfect for converting reference photos into tattoo stencils and visualizing ideas before your appointment.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Image to Tattoo Converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Simply upload your photo or reference image, choose your preferred tattoo style and body placement, and optionally describe your vision. Our AI tattoo generator processes your images and creates unique tattoo designs from photos in seconds — turning any picture into a custom tattoo concept.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I customize the tattoo designs generated by AI?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Absolutely! You can generate multiple variations by adjusting your text prompt, uploading different reference images, changing styles, or trying different placements. The tattoo AI creator gives you full creative control to explore different concepts until you find your perfect design.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I create a tattoo stencil or outline from my photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Yes! Lift's image to tattoo converter can transform your photos into clean tattoo outlines, line drawings, and stencils. Simply upload your image, select a line art or minimalist style, and our AI will convert your picture into a tattoo-ready outline perfect for your artist to work with.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter#why-lift',
			name: "Why Lift's Photo to Tattoo Converter stands out",
			description:
				"Lift's Photo to Tattoo Converter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Photo to tattoo converter showing AI-generated tattoo design previewed on back',
				description:
					"Comparison of Lift's Photo to Tattoo Converter benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/tattoo-from-photo-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Photo to Tattoo Converter',
					item: 'https://liftapp.ai/tattoo-from-photo-converter',
				},
			],
		},
	],
};
